import React from "react";

import useFileImportStore from "../../../../stores/fileImportStore";
import { COMPONENT_FIELD_MATCHER_CARD_TYPE } from "../../constants";
import FieldMatcherCard from "../FieldMatcherCard";
import ComponentCards from "./ComponentCards";

function ComponentDetailsMatcher() {
  const submittingToApi = useFileImportStore((s) => s.submittingToApi);
  return (
    <div style={{ visibility: submittingToApi ? "hidden" : "visible" }} className="d-flex gap-3 w-100">
      <div style={{ width: "50vw" }}>
        <FieldMatcherCard type={COMPONENT_FIELD_MATCHER_CARD_TYPE} />
      </div>
      <div style={{ width: "50vw" }}>
        <ComponentCards />
      </div>
    </div>
  );
}

export default ComponentDetailsMatcher;
